import { useContext } from "react";
import { AuthContext, AuthState } from "../contexts/JWTAuthcontext";

export const useAuth = () => useContext(AuthContext);
